// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 17-09-2025

/* eslint-disable import/no-anonymous-default-export */
import futureDemandReportTypes from './future-demand-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// Future Demand Report response
	fetchFutureDemandDetailResponse: null,
	// Future Demand Report array
	fetchFutureDemandDetailArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/***************** FETCH FUTURE DEMAND REPORT START *************** */
		case futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_SUCCESS:
			return {
				...state,
				fetchFutureDemandDetailResponse: action.payload,
				fetchFutureDemandDetailArr: docodeHexResponse(
					action.payload,
					'FutureDemandDetailsKey',
				),
			};

		case futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_FAILURE:
			return { ...state, fetchFutureDemandDetailResponse: action.payload };

		case futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchFutureDemandDetailResponse: null };
		/***************** FETCH FUTURE DEMAND REPORT END *************** */

		default:
			return state;
	}
};
